import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

export interface RegionOption {
  id: string;
  name: string;
}

@Component({
  selector: 'la-region-subregion-selector',
  templateUrl: './region-subregion-selector.component.html',
  styleUrl: './region-subregion-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
})
export class RegionSubregionSelectorComponent {
  formGroup = input.required<FormGroup>();
  availableRegions = input<RegionOption[]>([]);
  availableSubregionsToSelect = input<RegionOption[]>([]);

  get selectedSubregionsLabel(): string {
    const form = this.formGroup();
    const value: string[] = form?.get('subregions')?.value;
    if (!value || value.length === 0) {
      return '';
    }
    const options = this.availableSubregionsToSelect();
    return value
      .map((id) => options.find((subregion) => subregion.id === id)?.name)
      .filter((name) => !!name)
      .join(', ');
  }
}
